import axios from 'axios'
import { Toast } from 'antd-mobile'
import qs from 'qs'
import request from '../utils/request'
import hmacSha256 from 'crypto-js/hmac-sha256'

import { config } from './../config'
import { getLanguage } from './language'
import { cleanAuth } from './storage'

// const SUCCESS_STATUS = [10001, 31004, 31003, 30027, 30025, 30012, 30001, 49030]  // 响应成功的状态码
// 创建axios实例
const headers = {
  'Content-Type': 'application/x-www-form-urlencoded',
  Terminal: config.Terminal,
  Authorization: config.Authorization,
  cid: config.cid,
}

const service = axios.create({
  timeout: 30000, // 请求超时时间
  headers,
  withCredentials: true, // 这里设置了请求头是否携带cookie
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    const language = getLanguage()
    if (config.params) {
      config.params = { ...config.params, language }
      config.params = _getSignature(config.params)
    }

    if (config.data) {
      config.data = { ...config.data, language }
      config.data = _getSignature(config.data)
      config.data = qs.stringify(config.data)
    }

    const token = localStorage.getItem('token') || ''
    const accessJwtToken = localStorage.getItem('accessJwtToken') || ''
    if (token) {
      config.headers['token'] = token
    }
    if (accessJwtToken) {
      config.headers['X-ASSET-AUTH'] = accessJwtToken
    }

    if (language) {
      config.headers['X-Language'] = language
    }

    return config
  },
  (error) => {
    // Do something with request error
    Toast.fail(error.message || 'web请求错误, 请联系技术人员')
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const { data, config } = response
    if (data.code !== 10000 && data.code !== 49030) {
      if (data.message === 'BUSINESS_ERROR') {
        Toast.fail(
          `${data.message}\n${config.method} ${config.url}\n${JSON.stringify(
            config.params,
            null,
            2
          )}`,
          2
        )
      } else {
        Toast.fail(data.message, 2)
      }
      return Promise.reject(data.message)
    } else {
      if (data.code === 49030) {
        data.data.code = data.code
      }
      return data.data ? data.data : data
    }
  },
  (error) => {
    const { config } = error
    const refreshToken = localStorage.getItem('refreshToken') || ''
    if (
      error.response.status === 401 &&
      !config.url.includes('/refresh/token')
    ) {
      localStorage.removeItem('token')
      localStorage.removeItem('accessJwtToken')
      request({
        url: '/gateway/user/v1/manage/refresh/token',
        method: 'post',
        data: {
          refreshToken,
        },
      })
        .then((res) => {
          const { accessToken, accessJwtToken, refreshToken } = res
          localStorage.setItem('token', accessToken)
          localStorage.setItem('accessJwtToken', `Basic ${accessJwtToken}`)
          localStorage.setItem('refreshToken', refreshToken)
        })
        .catch(() => {
          //登录过期
          cleanAuth()

          // HACK: use frontend auth redirect
          window.location.reload()
        })
    }
    return Promise.reject(error)
  }
)

//获取签名
function _getSignature(params, method = 'GET') {
  if (typeof params !== 'object') {
    throw new Error('params必须为对象')
  }
  params['sign'] = ''
  let secretString = ''
  let keys = []
  for (var key in params) {
    if (
      undefined === params[key] ||
      '' === params[key] ||
      null === params[key]
    ) {
      continue
    }
    keys.push(key)
  }

  for (var i = 0; i < keys.length - 1; i++) {
    for (var j = i + 1; j < keys.length; j++) {
      if (keys[i] > keys[j]) {
        var temp = keys[i]
        keys[i] = keys[j]
        keys[j] = temp
      }
    }
  }

  for (var v in keys) {
    secretString +=
      keys[v] +
      '=' +
      encodeURIComponent(params[keys[v]])
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+')
        .replace(/\+/g, '%20') +
      '&'
  }

  var timestamp = new Date().getTime()

  // 拼接时间戳
  secretString += 'timestamp=' + timestamp

  // HmacSHA256加密
  var hash = hmacSha256(secretString, config.apiSecret) + ''

  params['timestamp'] = timestamp
  params['sign'] = hash.toUpperCase()
  return method === 'GET' ? params : formatParam(params)
}

function formatParam(params = {}) {
  let parameter = ''
  // params.language = 'zh_CN'
  for (var key in params) {
    if (typeof params[key] === 'object') {
      params[key] = JSON.stringify(params[key])
    }
    parameter += `${key}=${params[key]}&`
  }
  parameter = parameter.substr(0, parameter.length - 1)
  return parameter
}

export default service
